import { render, staticRenderFns } from "./newArticle.vue?vue&type=template&id=ea8c8de2&"
import script from "./newArticle.vue?vue&type=script&lang=js&"
export * from "./newArticle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports